module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Import_16"],"path":[{"$":{"d":"M3,13H6v2H1V1H6V3H3ZM15,6H11V3.5L5,8l6,4.5V10h4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Import_16.svg
// module id = tkoU
// module chunks = 1